<template>
  <v-data-table
    :headers="headers"
    :items="datos"
    item-key="ID_Desparasitacion"
    class="elevation-1"
    :search="search"
    :sort-by="'Nombre_Fac'"
    ref="datatable"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>
          <v-btn @click="excel" height="100%" dark color="green darken-1">
            <v-icon class="mb-2" large> fas fa-file-excel </v-icon>
          </v-btn>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- <v-switch
                            v-model="singleExpand"
                            label="Single expand"
                            class="mt-2"
                          ></v-switch> -->
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:item.cuantos="props">
      <v-dialog transition="dialog-bottom-transition">
        <template v-slot:activator="{ on, attrs }">
          <p
            @click="dataPorGruGru(props.item.grugru, props.item.cuantos)"
            color="primary"
            style="color: #2196f3; margin-bottom: 0"
            v-bind="attrs"
            v-on="on"
          >
            {{ props.item.cuantos }}
          </p>
        </template>
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar color="primary" dark>Datos Facturas Generadas</v-toolbar>
            <v-card-text>
              <simple-datatable
                style="margin-top: 1rem"
                :headers="headers2"
                :datos="datos2"
              >
              </simple-datatable>
              <simple-datatable
                style="margin-top: 1rem"
                :headers="headers3"
                :datos="datos3"
              >
              </simple-datatable>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn
                color="red accent-4"
                style="color: white"
                @click="dialog.value = false"
                >Cerrar</v-btn
              >
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </template>
    
    
  </v-data-table>
</template>

<script>
import axios from 'axios'
export default {
props: ['headers','datos'],
  data: () => ({
    search: ""
  }),
  created() {},
  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
  methods: {
    excel() {
      this.$store.state.stateLoad = true;
      axios({
        method: "post",
        url: "/excel",
        data: {
          datos: this.datos,
        },
        headers: {
          // Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        responseType: "blob",
      }).then((response) => {
        this.$store.state.stateLoad = false;
        // $("#boxLoading").removeClass("loading");
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "file.xlsx");
        document.body.appendChild(link);
        link.click();
        // console.log(response);
      });
    },
  },
};
</script>

<style></style>